import classNames from "classnames";
import { extendTailwindMerge, twJoin } from "tailwind-merge";

// The project's Tailwind preset renames the fontSize scale to xs/s/m/l/xl (damac-preset.js).
// tailwind-merge's default config only recognizes the stock scale (xs/sm/base/lg/xl/...), so
// without this extension it misclassifies "text-s"/"text-m"/"text-l" as text-color utilities
// and silently drops them whenever a text color class is merged alongside them.
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      "font-size": [{ text: ["xs", "s", "m", "l", "xl"] }],
    },
  },
});

function cn(...args: (string | undefined | null | false)[]) {
  return twMerge(classNames(args));
}

export function join(...args: (string | undefined | null | false)[]) {
  return twJoin(classNames(args));
}

export default cn;
